import { render, staticRenderFns } from "./discography.vue?vue&type=template&id=ef05f46e&scoped=true&"
import script from "./discography.vue?vue&type=script&lang=js&"
export * from "./discography.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef05f46e",
  null
  
)

export default component.exports